var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMessagerie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path_to_fill",
    d: "M14.9912 4C17.529 3.99875 19.9916 4.86198 21.9732 6.4475C23.911 8.00665 25.2575 10.1811 25.7653 12.5687C25.9216 13.2949 26.0003 14.0357 26 14.7785C26 17.6724 24.8882 20.3905 22.8689 22.4353C20.832 24.4958 18.0967 25.6302 15.1675 25.6302C14.1348 25.6302 12.8167 25.365 12.1832 25.1883C11.4211 24.9751 10.6987 24.6987 10.6192 24.6677C10.535 24.6355 10.4456 24.6188 10.3555 24.6186C10.2577 24.618 10.1608 24.6372 10.0707 24.6751L10.0289 24.6913L6.71469 25.8875C6.55194 25.9561 6.37801 25.9942 6.20152 26C5.86753 25.9984 5.54779 25.8645 5.3124 25.6276C5.07702 25.3906 4.9452 25.07 4.94585 24.736C4.94878 24.609 4.9686 24.483 5.00478 24.3613L5.90933 21.0878C5.94715 20.967 5.90442 20.8472 5.84893 20.749L5.83813 20.7293C5.8342 20.7229 5.81652 20.6974 5.80228 20.6778C5.78804 20.6581 5.7738 20.638 5.76005 20.6179L5.75072 20.6046C4.60884 18.8739 4.00012 16.8461 4.00005 14.7726C3.99121 11.9446 5.09759 9.27067 7.11638 7.24549C9.2054 5.15255 11.9996 4 14.9912 4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 1,
    className: "path_to_fill_white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1,
    className: "path_to_fill_white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 1,
    className: "path_to_fill_white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessagerie);
export default __webpack_public_path__ + "static/media/icon_messagerie.688eb4d745ba5c3c7ca73547389998ff.svg";
export { ForwardRef as ReactComponent };